export default (): InternalReviewsState => ({
  internalReviews: []
})
